import type { PageTour } from '../types';

export const clientsTour: PageTour = {
  id: 'clients',
  label: 'Clients Tour',
  steps: [
    {
      target: '[data-tour="clients-header"]',
      title: 'Client Management',
      content: 'Manage your organization\'s clients. View client details, associated projects, and contact information.',
    },
    {
      target: '[data-tour="clients-list"]',
      title: 'Client List',
      content: 'Browse all your clients. Each entry shows the client name, status, and number of associated projects.',
    },
    {
      target: '[data-tour="clients-create"]',
      title: 'Add a Client',
      content: 'Click here to add a new client to your organization. Fill in their details and link them to projects.',
    },
  ],
};
